import { ForwardedRef, forwardRef, ReactNode } from "react";

// material-ui
import {
  Card,
  CardContent,
  CardHeader,
  CardProps,
  Divider,
  Typography,
  useTheme,
} from "@mui/material";

// constant
const headerSX = {
  "& .MuiCardHeader-action": { mr: 0 },
};

type MainCardProps = CardProps & {
  border: boolean;
  boxShadow: boolean;
  children: ReactNode;
  content?: boolean;
  contentClass?: string;
  contentSX?: object;
  darkTitle?: boolean;
  secondary?: any;
  shadow: string;
  sx?: object;
  title?: any;
};

const MainCard = forwardRef(
  (
    {
      border = true,
      boxShadow,
      children,
      //@ts-ignore
      content = true,
      contentClass = "",
      contentSX = {},
      darkTitle,
      secondary,
      shadow,
      sx = {},
      title,
      ...rest
    }: MainCardProps,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    const theme = useTheme();

    return (
      <Card
        ref={ref}
        {...rest}
        sx={{
          border: border ? "1px solid" : "none",
          borderColor: theme.palette.primary.main,
          ":hover": {
            boxShadow: boxShadow
              ? shadow || "0 2px 14px 0 rgb(32 40 45 / 8%)"
              : "inherit",
          },
          ...sx,
        }}
      >
        {/* card header and action */}
        {!darkTitle && title && (
          <CardHeader sx={headerSX} title={title} action={secondary} />
        )}
        {darkTitle && title && (
          <CardHeader
            sx={headerSX}
            title={<Typography variant="h3">{title}</Typography>}
            action={secondary}
          />
        )}

        {/* content & header divider */}
        {title && <Divider />}

        {/* card content */}
        {content && (
          <CardContent sx={contentSX} className={contentClass}>
            {children}
          </CardContent>
        )}
        {!content && children}
      </Card>
    );
  }
);

export default MainCard;
